import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";
import { RESET_STATE } from "../actions";

const initialState = {} as IUserAcceptance;

const userAcceptanceSlice = createSlice({
    name: "userAcceptance",
    initialState,
    reducers: {
        setUserAcceptance: (state, action: PayloadAction<IUserAcceptance | undefined>) => {
            Object.assign(state, { ...action.payload });
        },
    },
    extraReducers: (builder) => {
        builder.addCase(RESET_STATE, () => initialState);
    },
});

export const { setUserAcceptance } = userAcceptanceSlice.actions;
export default userAcceptanceSlice.reducer;

export const getUserAcceptance = (state: RootState) => state.userAcceptance;
